import React, { useState, useEffect } from "react";
import "./contact.css";

const Contact = () => {
    const [content, setContent] = useState({
        contact_title: "Get in Touch",
        contact_subtitle: "Let's connect and discuss your next game project.",
        contact_note: "I'm always available for new collaborations and opportunities.",
        socials: [
            { name: "LinkedIn", icon: "fa-brands fa-linkedin", url: "https://www.linkedin.com/in/prabindrasapkota/" },
            { name: "GitHub", icon: "fa-brands fa-github-square", url: "https://github.com/Parzival-101" },
            { name: "Twitter", icon: "fa-brands fa-twitter-square", url: "https://twitter.com/Prabindra101" },
            { name: "Facebook", icon: "fa-brands fa-facebook-square", url: "https://www.facebook.com/PrabindraSapkota101" },
            { name: "Instagram", icon: "fa-brands fa-instagram-square", url: "https://www.instagram.com/prabindrasapkota/" },
            { name: "Email", icon: "fa-solid fa-envelope", url: "mailto:prabindrasapkota89@gmail.com" }
        ]
    });

    useEffect(() => {
        fetch("/content.json")
            .then(res => res.json())
            .then(data => {
                setContent({
                    contact_title: data.contact_title || content.contact_title,
                    contact_subtitle: data.contact_subtitle || content.contact_subtitle,
                    contact_note: data.contact_note || content.contact_note,
                    socials: data.socials || content.socials
                });
            })
            .catch(err => console.log("Using default contact content"));
    }, []);

    return (
        <section id="contact" className="py-20 md:py-28 transition-colors duration-300">
            <div className="max-w-5xl mx-auto px-4 md:px-6 lg:px-8">
                <div className="bg-white dark:bg-gray-800 p-8 md:p-12 rounded-xl border border-gray-200 dark:border-gray-700 shadow-lg">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                        <div>
                            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-gray-100 mb-4">{content.contact_title}</h2>
                            <p className="text-lg text-gray-600 dark:text-gray-400 mb-2">{content.contact_subtitle}</p>
                            <p className="text-base text-gray-500 dark:text-gray-500">{content.contact_note}</p>
                        </div>

                        <div>
                            <ul className="flex flex-wrap gap-4 items-center justify-center md:justify-end text-2xl md:text-3xl">
                                {content.socials && content.socials.map((social, idx) => {
                                    let hoverClass = "hover:text-blue-600 dark:hover:text-blue-400";
                                    if (social.name === "GitHub") hoverClass = "hover:text-gray-900 dark:hover:text-gray-100";
                                    if (social.name === "Twitter") hoverClass = "hover:text-blue-400 dark:hover:text-blue-300";
                                    if (social.name === "Facebook") hoverClass = "hover:text-blue-600 dark:hover:text-blue-500";
                                    if (social.name === "Instagram") hoverClass = "hover:text-pink-600 dark:hover:text-pink-400";
                                    if (social.name === "Email") hoverClass = "hover:text-red-600 dark:hover:text-red-400";
                                    
                                    return (
                                        <li key={idx}>
                                            <a href={social.url} target="_blank" rel="noopener noreferrer" className={`text-gray-600 dark:text-gray-400 ${hoverClass} transition-colors duration-200 hover:scale-110 transform`}>
                                                <i className={social.icon}></i>
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
